import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {useEffect} from 'react';
import {setDarkModeForUserPreference} from 'components/DarkModeButton/DarkModeButton';
import {enableDarkMode} from 'utils/darkMode';
import {captureReturnToFromUrl} from 'surveys/osa_funnel/survey/returnTo';
import 'surveys/osa_funnel/osaShell.css';
import {
  OsaCheckoutConfirmScreenContainer,
  OsaCheckoutScreenContainer,
  OsaScreeningScreenContainer,
  OsaSurveyScreenContainer,
} from 'OsaConfigScreens';

const OsaRootRedirect = () => {
  const location = useLocation();
  const to = `/osa/start${location.search}`;
  return <Navigate to={to} replace />;
};

export const OsaRoutes = () => {
  // The main web funnel (onboarding.risescience.com / rise-web-funnel v2)
  // is light-only — it never activates dark mode. Force light here so the
  // OSA funnel matches it for a seamless redirect, and so the RISE wordmark
  // doesn't invert to white-on-white on a dark-OS device (RiseHeader has a
  // `[data-theme='dark'] .logo { filter: invert }` rule). Restore the OS
  // preference on unmount so the rest of the app keeps its behaviour.
  useEffect(() => {
    enableDarkMode(false);
    return () => {
      setDarkModeForUserPreference();
    };
  }, []);

  // Capture ?returnTo= into sessionStorage on entry so the exit redirect
  // survives even if a later navigation drops the query string. The URL
  // param still takes priority in readReturnToFromUrl; this is the fallback.
  useEffect(() => {
    captureReturnToFromUrl();
  }, []);

  // Tag <body> so the OSA funnel can opt into the onboarding.risescience
  // .com shell treatment (centered shadowed card on desktop, full-bleed
  // white on mobile) without affecting the insomnia clinic intake, which
  // shares the same survey shell + global CSS.
  useEffect(() => {
    document.body.classList.add('osa-funnel');
    return () => {
      document.body.classList.remove('osa-funnel');
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<OsaRootRedirect />} />
      <Route index path="start" element={<OsaSurveyScreenContainer />} />
      <Route path="checkout" element={<OsaCheckoutScreenContainer />} />
      <Route path="checkout/confirm" element={<OsaCheckoutConfirmScreenContainer />} />
      <Route path="screening" element={<OsaScreeningScreenContainer />} />
    </Routes>
  );
};
